import React, { forwardRef, useLayoutEffect } from 'react'
import cx from 'classnames'

import { TooltipContent } from './TooltipContent'

import styles from './Tooltip.module.css'

interface TipProps {
  content: string
  width?: number
  className?: string
  onUpdate?: () => void
}

export const Tip = forwardRef<HTMLDivElement, TipProps>((props, _ref) => {
  const { content, className, width } = props

  useLayoutEffect(() => {
    if (props.onUpdate) {
      props.onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content, width])

  return (
    <div ref={_ref} className={cx(className, styles.show)}>
      <TooltipContent content={content} width={width} />
    </div>
  )
})
